import React, { useState, useEffect } from "react";
import { navigate } from "gatsby";

import GlobalContext from "../../../contexts/globalContext";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import Searcher from "../../molecules/searcher/searcher";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

import "./genreSelector.scss";

const GenreSelector = (props: ReferenciaContenido) => {
  const { tituloGeneral, referenciaPlantillaContenido, contentType } = props;
  const [showOptions, setShowOptions] = useState(false);
  const [selection, setSelection] = useState("Tema");
  const [genderSelected, setGenderSelected] = useState<number | null>(null);
  const { isBrowser, window } = useBrowserMode();

  useEffect(() => {
    if (genderSelected !== null) {
      const subjects = referenciaPlantillaContenido[genderSelected].tipoTitulo
        .split(",")
        .join("/");
      const text = referenciaPlantillaContenido[genderSelected].tituloBanner;
      navigate(`/ver-todo/?title=${props.autoresArticulo[0]} (${text})` +
      `&searchType=filter` +
      `&contentType=Libros` + 
      `&searchParam=word,contentType` +
      `&paramValues=/-${props.tipoLibro || "book"}/-${subjects}`,
       {
        state: {},
      });
    }
  }, [genderSelected]);

  useEffect(() => {
    if (isBrowser) {
      const handleClick = (e: any) => {
        if (
          e.target.className.indexOf(
            "o-genre-selector__title-section__dropdown"
          ) === -1 &&
          e.target.className.indexOf(
            "o-genre-selector__title-section__dropdown__title"
          ) === -1 &&
          e.target.className.indexOf("icon-chevron-down1") === -1 &&
          e.target.className.indexOf(
            "o-genre-selector__title-section__dropdown__options__option"
          ) === -1 &&
          showOptions
        ) {
          setShowOptions(false);
          toogleFreeze(false);
        }
      };
      
      window.addEventListener("click", handleClick);
      
      return () => {
        window.removeEventListener("click", handleClick);
      };
    }
    
  }, [isBrowser]);

  const toogleFreeze = (isToggle: boolean) => {
    isToggle && isBrowser && window.screen.width < 769
      ? document.body.classList.add("freeze-page")
      : document.body.classList.remove("freeze-page");
  };

  const setGender = (
    thematic: string,
    gender: any,
    indexGender: number,
    text: string
  ) => {
    gender.set(thematic);
    setSelection(text);
    setShowOptions(false);
    toogleFreeze(false);
    setGenderSelected(indexGender);
  };

  const showOptionsFn = (show: boolean) => {
    setShowOptions(show);
    toogleFreeze(show);
  };

  return (
    <GlobalContext.Consumer>
      {(data) => (
        <div className="o-genre-selector">
          <div className="o-genre-selector__title-section">
            <h1 className="o-genre-selector__title-section__title">
              {tituloGeneral}
            </h1>
            <div className="o-genre-selector__title-section__dropdown">
              <p
                className="o-genre-selector__title-section__dropdown__title"
                onClick={() => showOptionsFn(!showOptions)}
              >
                {selection}
                <span
                  className={
                    showOptions ? "icon-chevron-up1" : "icon-chevron-down1"
                  } 
                  // onClick={() => showOptionsFn(!showOptions)}
                ></span>
              </p>
              {showOptions && (
                <div className="o-genre-selector__black-bg"></div>
              )}
              {showOptions && (
                <ul
                  className={`o-genre-selector__title-section__dropdown__options
                  ${
                    referenciaPlantillaContenido.length > 6
                      ? "o-genre-selector__title-section__dropdown__options-scroll"
                      : ""
                  }`}
                >
                  <li
                    className="o-genre-selector__title-section__dropdown__options__close
                    icon-close"
                    onClick={() => showOptionsFn(false)}
                  ></li>
                  <li
                    className="o-genre-selector__title-section__dropdown__options__option
                    o-genre-selector__title-section__dropdown__options__option__disabled"
                  >
                    Selecciona un tema
                  </li>
                  {referenciaPlantillaContenido.map((el, index) => (
                    <li
                      className={`o-genre-selector__title-section__dropdown__options__option gtm${normalizeTwoWords(
                        props.nombreCategoria || props.tituloGeneral
                      )}SelectorGenero${normalizeTwoWords(el.tituloBanner)}`}
                      onClick={() =>
                        setGender(
                          el.tipoTitulo,
                          data.genreSelected,
                          index,
                          el.tituloBanner
                        )
                      }
                      key={index}
                    >
                      {el.tituloBanner}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <p className="o-genre-selector__description">
            {props.descripcion.json.content[0].content[0].value}
          </p>
          <div className="o-genre-selector__searcher">
            <Searcher
              type="biblioteca"
              compact={true}
              noTabs={false}
              defaultPlaceholder=""
              autoFocus={false}
              filterSelection={["Todos"]}
            />
          </div>
        </div>
      )}
    </GlobalContext.Consumer>
  );
};

export default GenreSelector;
